import { forwardRef, type Ref, type SVGProps } from "react";
const IconSortFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M18.17 19.52a2 2 0 0 0-2.94 2.71l5.65 6.13a2 2 0 0 0 2.94 0l5.65-6.13a2 2 0 0 0-2.94-2.71l-2.19 2.37V5a2 2 0 0 0-4 0v16.88zM9.66 29a2 2 0 0 1-2-2V10.11l-2.19 2.37a2 2 0 0 1-2.94-2.71l5.65-6.13a2 2 0 0 1 2.94 0l5.65 6.13a2 2 0 0 1-2.94 2.71l-2.17-2.36V27a2 2 0 0 1-2 2" />
  </svg>
);
const ForwardRef = forwardRef(IconSortFilledSVG);
ForwardRef.displayName = "IconSortFilled";
export { ForwardRef as IconSortFilled };
